import { render, staticRenderFns } from "./ModeratorNavigationDrawer.vue?vue&type=template&id=f169ae54"
import script from "./ModeratorNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./ModeratorNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports